module.exports = __webpack_public_path__ + "img/agency-partnership-manager.abd576b4.svg";